module.exports = __webpack_public_path__ + "static/media/max_and_karl.da6b3bea.jpg";